import { jsx as _jsx } from "react/jsx-runtime";
/********************************************************************************
 * Copyright (c) 2019 TypeFox and others
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 ********************************************************************************/
import { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
export const ExtensionRatingStarSetter = props => {
    const [rating, setRating] = useState(1);
    const handleStarClick = (rating) => {
        setRating(rating);
        props.handleRatingChange(rating);
    };
    const renderStarButton = (number) => {
        return (_jsx(IconButton, { onClick: () => handleStarClick(number), children: number <= rating ? _jsx(StarIcon, {}) : _jsx(StarBorderIcon, {}) }, 'starbtn' + number));
    };
    const renderStars = () => {
        const stars = [];
        for (let i = 1; i <= 5; i++) {
            stars.push(renderStarButton(i));
        }
        return stars;
    };
    return _jsx(Box, { children: renderStars() });
};
//# sourceMappingURL=extension-rating-star-setter.js.map